<template>
  <v-app>
    <header class="site-header">
      <button class="brand" type="button" @click="scrollTo('top')">CHER</button>
      <nav aria-label="Main navigation">
        <button type="button" @click="scrollTo('collection')">Fragrances</button>
        <button type="button" @click="scrollTo('car-aromas')">Car aromas</button>
        <a href="https://www.instagram.com/cher_goa" target="_blank" rel="noopener">Our story</a>
      </nav>
      <button class="bag-button" type="button" aria-label="Open shopping bag" @click="cartOpen = true">
        <v-icon size="21">mdi-shopping-outline</v-icon>
        <span>Bag</span>
        <b v-if="itemCount">{{ itemCount }}</b>
      </button>
    </header>

    <v-main id="top">
      <HomePage @add-to-cart="addToCart" />
    </v-main>

    <CartDrawer
      v-model="cartOpen"
      :items="cartItems"
      :checkout="checkout"
      :whatsapp-link="whatsappLink"
      @remove="removeFromCart"
      @quantity="updateQuantity"
      @update-checkout="updateCheckout"
      @shop="scrollTo('collection')"
    />

    <transition name="toast">
      <div v-if="toastVisible" class="cart-toast">
        <v-icon color="white" size="18">mdi-check</v-icon>
        Added to your bag
        <button type="button" @click="cartOpen = true">View bag</button>
      </div>
    </transition>
  </v-app>
</template>

<script>
import Vue from 'vue'
import HomePage from './components/HomePage.vue'
import CartDrawer from './components/CartDrawer.vue'
import { createWhatsAppLink } from './utils/order'

export default {
  name: 'App',
  components: { HomePage, CartDrawer },
  data: () => ({
    cart: {},
    cartOpen: false,
    toastVisible: false,
    toastTimer: null,
    checkout: {
      deliveryOption: 'pickup',
      mapsLink: '',
      deliveryDateTime: '',
      isGift: false,
      giftMessage: ''
    }
  }),
  computed: {
    cartItems() {
      return Object.values(this.cart)
    },
    itemCount() {
      return this.cartItems.reduce((count, item) => count + item.quantity, 0)
    },
    whatsappLink() {
      return createWhatsAppLink(this.cartItems, this.checkout)
    }
  },
  methods: {
    addToCart(item) {
      const existing = this.cart[item.cartKey]
      Vue.set(this.cart, item.cartKey, {
        ...item,
        quantity: existing ? existing.quantity + 1 : 1
      })
      this.toastVisible = true
      clearTimeout(this.toastTimer)
      this.toastTimer = setTimeout(() => { this.toastVisible = false }, 2200)
    },
    removeFromCart(key) {
      Vue.delete(this.cart, key)
    },
    updateQuantity({ key, change }) {
      const item = this.cart[key]
      if (!item) return
      const quantity = item.quantity + change
      if (quantity < 1) return this.removeFromCart(key)
      Vue.set(this.cart, key, { ...item, quantity })
    },
    updateCheckout({ key, value }) {
      Vue.set(this.checkout, key, value)
      if (key === 'isGift' && !value) Vue.set(this.checkout, 'giftMessage', '')
    },
    scrollTo(id) {
      document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>

<style>
* { box-sizing: border-box; }
html { scroll-behavior: smooth; }
body { margin: 0; font-family: Inter, sans-serif; background: #faf8f4; }
button, select, input, textarea { font-family: inherit; }
button, select { cursor: pointer; }
.v-application { color: #28241f !important; font-family: Inter, sans-serif !important; background: #faf8f4 !important; }
.site-header {
  height: 74px;
  position: fixed;
  z-index: 20;
  top: 0;
  right: 0;
  left: 0;
  display: grid;
  grid-template-columns: 1fr auto 1fr;
  align-items: center;
  padding: 0 4vw;
  border-bottom: 1px solid rgba(57,48,39,.12);
  background: rgba(247,243,237,.91);
  backdrop-filter: blur(16px);
}
.brand { justify-self: start; border: 0; color: #24201c; background: transparent; font-family: mulegh, Georgia, serif; font-size: 40px; line-height: 1; letter-spacing: 3px; }
.site-header nav { display: flex; align-items: center; gap: 32px; }
.site-header nav button, .site-header nav a { border: 0; color: #645c53; background: transparent; font-size: 11px; font-weight: 700; text-decoration: none; }
.bag-button { justify-self: end; display: flex; align-items: center; gap: 7px; border: 0; color: #2b2722; background: transparent; font-size: 11px; font-weight: 700; }
.bag-button b { min-width: 20px; height: 20px; display: grid; place-items: center; border-radius: 50%; color: #fff; background: #a96d47; font-size: 9px; }
.v-main { padding-top: 74px !important; }
.cart-toast { position: fixed; z-index: 30; right: 22px; bottom: 22px; display: flex; align-items: center; gap: 9px; padding: 13px 16px; border-radius: 9px; color: #fff; background: #27231e; box-shadow: 0 12px 30px rgba(36,29,23,.25); font-size: 12px; }
.cart-toast button { margin-left: 12px; border: 0; border-bottom: 1px solid #b69e8d; color: #e1d8cf; background: transparent; font-size: 10px; font-weight: 700; }
.toast-enter-active, .toast-leave-active { transition: opacity .2s, transform .2s; }
.toast-enter, .toast-leave-to { opacity: 0; transform: translateY(10px); }
@media (max-width: 650px) {
  .site-header { grid-template-columns: 1fr auto; padding: 0 17px; }
  .site-header nav { display: none; }
  .bag-button span { display: none; }
}
</style>
